/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const MailIcon = ({
  title = 'Mail',
  viewBox = '0 0 24 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M18.955 2.484H5.045l6.71 4.904c.132.095.305.105.444.028l.045-.028 6.71-4.904zM.775.09A1.236 1.236 0 000 1.263v13.22c0 .685.556 1.241 1.242 1.241h21.517c.685 0 1.241-.556 1.241-1.241V1.242a1.231 1.231 0 00-.29-.799A1.233 1.233 0 0022.734 0H1.265a1.248 1.248 0 00-.49.091zm19.092 13.151L15.04 8.42l-1.331.972a2.897 2.897 0 01-3.322.068l-.096-.068-1.273-.93-4.786 4.78h15.635zm1.65-1.861V3.686L17.07 6.937l4.448 4.444zM2.483 3.686v7.794L6.989 6.98 2.483 3.686z" />
  </CreateIconComponent>
);

export default MailIcon;
